import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export default makeStyles((theme: Theme) => ({
  list: {
    listStyle: "none",
    padding: "0",
    margin: `0 0 0 ${theme.spacing(2)}`,
    ...theme.typography.body2,

    "& > li": {
      position: "relative",
      paddingLeft: theme.spacing(2),
    },

    "& > li::before": {
      content: "'•'",
      position: "absolute",
      left: theme.spacing(-1),
    },
  },
}));
